import styled from 'styled-components';
import { ContainerBaseModalComment } from '../styles';

export const Container = styled(ContainerBaseModalComment)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: stretch;
  max-height: calc(100vh - 460px);
  overflow: auto;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
`;

